<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<!--<header class="topbar" style="background-color: #f3f3f3; padding-bottom: 40px; margin-left: 2Opx!important; margin-right: 20px!important;">
  <nav class="d-flex top-navbar navbar-expand-md">
    <div class="navbar-header">
      <a class="navbar-brand" href="/">
        &lt;!&ndash; Logo icon &ndash;&gt;
        <b class="logo-icon">
          &lt;!&ndash;You can put here icon as well // <i class="wi wi-sunset"></i> //&ndash;&gt;
          &lt;!&ndash; Dark Logo icon &ndash;&gt;
          <img src="assets/images/logo-icon.png" style="width: 90px; height: 100% ;background-color: #264192 "
               alt="homepage" class="dark-logo"/>
          &lt;!&ndash; Light Logo icon &ndash;&gt;
          <img src="assets/images/logo-icon.png" style="width: 90px; height: 100% ; background-color: #264192 "
               alt="homepage" class="light-logo"/> <span style="font-size: 24px; color : gray"> |</span> <span
          style="color: gray; font-size: 14px">Back Office</span>
        </b>
      </a>

    </div>
  </nav>
</header>-->
<router-outlet></router-outlet>
